
import {
  defineComponent, toRefs, reactive,
} from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import { Pagination, Table } from 'ant-design-vue';

import '@/assets/icons/back.svg';
import { useRouter } from 'vue-router';
import useReportHooks, { TableDataTeacher as TableData } from '@/hooks/report.hooks';
import useHooks from '@/hooks/index.hooks';
import { Page } from '@/interface/index.interface';
import { cloneDeep } from '@/lib';
import { definitions } from '@/types/api';
import reportService from '@/services/report.services';
import { baseURL } from '@/axios/fetch';

export default defineComponent({
  components: {
    ManagementFrame,
    SvgIcon,
    aTable: Table,
    aPagination: Pagination,
  },
  setup() {
    const { getPageOption } = useHooks();
    const router = useRouter();
    const reportHooks = useReportHooks();
    const { queryExperimentExcel } = reportService();
    const tableData = reactive<Page & TableData>({
      tableList: [],
      tableLoading: false,
      columns: reportHooks.columnTeacher(),
      /** */
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pageOption: cloneDeep(getPageOption),
    });

    const getList = async () => {
      tableData.tableLoading = true;
      const { pageNo, pageSize } = tableData;
      const { list, total } = await reportHooks.listTeaExperimentByTeacher({ pageNo, pageSize });
      Object.assign(tableData, {
        tableList: list, total, tableLoading: false,
      });
    };

    const tableMethod = reactive({
      getStatus: (record: definitions['Experiment']) => {
        if (record.status === 0) return '未开始';
        if (record.status === 1) return '进行中';
        if (record.status === 2) return '已结束';
        return '-';
      },
      /** 进入实验班级页 */
      gotoInfo: (record: definitions['Experiment']) => {
        console.log(record);
        reportHooks.currentReportExperimentName.set(record.experimentName || '');
        reportHooks.currentReportDate.set(record.createTime || '');
        router.push({
          path: `/Teacher/reportMember/${record.id}`,
        });
      },
      /** 下载 */
      downLoad: async (record: definitions['Experiment']) => {
        const fileName = await queryExperimentExcel(record.id!);
        window.open(`${baseURL}/${fileName}`, '_blank');
        console.log(fileName, baseURL);
      },
      /** 是否能下载 */
      isEnd: (record: definitions['Experiment']) => {
        if (record.status === 2) return false;
        return true;
      },
      /** 返回 */
      back: () => {
        router.back();
      },
    });

    const pageMethod = reactive({
      showSizeChange: (_: unknown, size: number) => {
        tableData.pageSize = size;
        tableData.pageNo = 1;
        getList();
      },
      pageChange: (page: number) => {
        tableData.pageNo = page;
        getList();
      },
    });

    getList();
    return {
      ...toRefs(tableData),
      ...toRefs(tableMethod),
      ...toRefs(pageMethod),
    };
  },
});
